// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dreepy: PokeData = {
  "id": 885,
  "name": "dreepy",
  "height": 5,
  "weight": 20,
  "base_experience": 54,
  "types": [
    PokeType.DRAGON,
    PokeType.GHOST
  ],
  "api_moves": [
    "bite",
    "quick-attack",
    "astonish",
    "infestation"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "outrage",
    "dragon-rush",
    "draco-meteor",
    "confuse-ray",
    "dragon-claw",
    "shadow-ball",
    "spectral-snatch",
    "curse",
    "soul-sacrifice",
    "night-shade",
    "dragon-breath"
  ],
  "evolution_chain": {
    "id": 466,
    "item": null,
    "species": [
      {
        "name": "dreepy",
        "order": 885,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drakloak",
        "order": 886,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 885,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 50,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dragapult",
        "order": 887,
        "types": [
          PokeType.DRAGON,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 886,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 60,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 29,
    "speed": 82,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
